module.exports = (__webpack_require__(72963))(906);